import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { aiPlanningEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningEntrypoint.entrypoint.tsx';
import { aiPlanningPlannerRedirectEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningPlannerRedirectEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { softwareAiPlanningClassicRoute } from '@jira/router-routes__software-ai-planning-routes/src/softwareAiPlanningClassicRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const aiPlanningClassicSoftwarePageEntrypoint = createPageEntryPoint({
	main: aiPlanningEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

const aiPlanningPlannerRedirectPageEntrypoint = createPageEntryPoint({
	main: aiPlanningPlannerRedirectEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const softwareAiPlanningClassicRouteEntry: Route = createEntry(
	softwareAiPlanningClassicRoute,
	() => ({
		group: 'classic-software',
		/* eslint-disable jira/ff/no-preconditioning -- temporary route handoff keeps the old route alive until the rename gate is fully launched. */
		isRedirect: fg('jira_ai_planner_tab') && fg('ai-planner-jira-monolith-route-rename'),
		ufoName: 'software-ai-planning-classic',
		layout: classicSoftwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			projectThemeResource,
		],

		meta: {
			reporting: {
				id: 'software-ai-planning-classic',
				packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
				teamName: 'Dev AI - Planner',
			},
		},

		entryPoint: () => {
			if (!fg('jira_ai_planner_tab')) {
				return notFoundPageEntrypoint;
			}

			if (fg('ai-planner-jira-monolith-route-rename')) {
				return aiPlanningPlannerRedirectPageEntrypoint;
			}

			return aiPlanningClassicSoftwarePageEntrypoint;
		},
		/* eslint-enable jira/ff/no-preconditioning */

		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
